























import { Component, Vue, Prop } from 'vue-property-decorator';

type Image = {
  src: string;
  alt?: string;
};

@Component
export default class Thumb extends Vue {
  @Prop({ default: 32 }) size?: number | string;
  @Prop({ default: 0 }) gutter?: number;
  @Prop({ default: { alt: '' } }) image!: Image;
  @Prop({ default: false }) showStarLayer?: boolean;
  @Prop({ default: '' }) bg?: string;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: 'default' }) variant?: 'default' | 'image-border';

  get containerStyles() {
    const size = this.size || '100%';

    const baseContainerStyles: Record<string, any> = {
      padding: `${this.gutter}px`,
      backgroundColor: this.bg
    };

    const sizeIsString = typeof size === 'string';

    return {
      ...baseContainerStyles,
      width: sizeIsString ? size : `${size}px`,
      height: sizeIsString ? size : `${size}px`
    };
  }

  get starStyle() {
    return {
      width: `calc(100% - ${(this.gutter as number) * 2}px)`,
      height: `calc(100% - ${(this.gutter as number) * 2}px)`
    };
  }
}
